import { SecLoanAttachment, SecLoansApplicationMetadata } from '@shared/sec-loans'
import { OptionalAndNullable } from '@shared/typeHelpers'
import { getFiIntl } from '@ui-common/utils'
import { debugLog } from '@ui-common/utils/helpers'
import { FieldName, FieldValues } from 'react-hook-form'
import { IntlShape } from 'react-intl'
import { Suite } from 'vest'

import { messages } from '../l10n/messages'
import { getApplicantInfoPhaseData } from './steps/applicant-info-phase/phaseData'
import { getLoanInfoPhaseData } from './steps/loan-info-phase/phaseData'
import { getTargetInfoPhaseData } from './steps/loan-target-phase/phaseData'
import { WizardData } from './types'
import { ValidationParams } from './wizardMachine'

export const getAppData = (
  applicationData: WizardData,
  metadata: SecLoansApplicationMetadata,
  validationParams: ValidationParams,
  attachments?: SecLoanAttachment[],
): WizardData => {
  const targetInfoPhaseData = getTargetInfoPhaseData(applicationData, metadata, validationParams)
  const targetInfoValidated: WizardData = { ...applicationData, targetInfo: targetInfoPhaseData?.targetInfo }
  const applicantInfoPhaseData = getApplicantInfoPhaseData(targetInfoValidated, metadata)
  const targetAndApplicantInfoValidated: WizardData = {
    ...applicationData,
    targetInfo: targetInfoPhaseData?.targetInfo,
    applicantInfo: applicantInfoPhaseData?.applicantInfo,
  }
  const loanInfoPhaseData = getLoanInfoPhaseData(targetAndApplicantInfoValidated, metadata, validationParams)

  const appData: WizardData = {
    ...targetInfoPhaseData,
    ...applicantInfoPhaseData,
    ...loanInfoPhaseData,
    attachments,
  }

  appData.isComplete =
    targetInfoPhaseData?.targetInfo?.isComplete &&
    applicantInfoPhaseData?.applicantInfo?.isComplete &&
    loanInfoPhaseData?.loanInfo?.isComplete

  return appData
}

const { formatMessage } = getFiIntl(messages.fi)

export const isFormDataValid = <TDataParam extends FieldValues>(
  data: OptionalAndNullable<TDataParam> | undefined,
  createFormValidator: (
    formatMessage: IntlShape['formatMessage'],
  ) => Suite<string, string, (data: TDataParam, changedFields?: FieldName<TDataParam>[]) => void>,
): boolean => {
  if (!data) {
    return false
  }

  const suite = createFormValidator(formatMessage)
  const runAllValidations = undefined
  const result = suite(data as TDataParam, runAllValidations)

  const errors = result.getErrors()
  debugLog('isFormDataValid', errors)

  return !!result.valid
}
